function sanitizeEmailAddress(emailAddress) {
  // emailAddress = encodeURIComponent(emailAddress.replace(/\+/g, "");
  emailAddress = encodeURIComponent(emailAddress);
  return emailAddress;
}

module.exports = {
  sanitizeEmailAddress,
};



// WEBPACK FOOTER //
// ./library/app/utils/sanitizeUtils.js